<template>
  <div class="p-6 flex flex-col lg:flex-row items-start gap-6">
    <WelcomeUser />
    <ModuleList :modules="modules"/>
  </div>
</template>

<script>
import { Link } from '@inertiajs/vue3';
import WelcomeUser from '@/Components/WelcomeUser.vue';
import ModuleList from '@/Components/ModuleList.vue';

export default {
  components: {
    Link,
    WelcomeUser,
    ModuleList
  },
  props: ['modules']
};
</script>